"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mendicino": {
    "dc167a5f": [{
      "hkey": "086ba09b",
      "slug": "tivolille-pasquali-merenzata",
      "name": "Tivolille Pasquali-Merenzata",
      "primary": true,
      "skipSearch": false
    }],
    "di-pasquali": [{
      "hkey": "086ba09b",
      "slug": "tivolille-pasquali-merenzata",
      "name": "Tivolille Pasquali-Merenzata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "mendicino"
    }],
    "55835c7b": [{
      "hkey": "086ba09b",
      "slug": "tivolille-pasquali-merenzata",
      "name": "Tivolille Pasquali-Merenzata",
      "primary": true,
      "skipSearch": false
    }],
    "tivolille": [{
      "hkey": "086ba09b",
      "slug": "tivolille-pasquali-merenzata",
      "name": "Tivolille Pasquali-Merenzata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;